import { AfterViewInit, Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { CxService } from "../../services";

interface EscalationData
{
    message: string;
    brandId: string;
    channelId: string;
    reason?: string;
    priority?: string;
    timestamp?: string;
}

@Component({
    selector: "escalation-chat",
    templateUrl: "./escalationChat.tmpl.html",
    styleUrls: ["./escalationChat.component.scss"],
    standalone: false
})
export class EscalationChatComponent implements AfterViewInit
{
    escalationMessage: string;
    escalationDetails: {
        reason?: string;
        priority?: string;
        timestamp?: string;
    } = {};

    isLoading = true;
    error: string | null = null;

    constructor(
        private route: ActivatedRoute,
        private $cxService: CxService
    ) {}

    ngAfterViewInit(): void
    {
        const storedData = sessionStorage.getItem("escalationData");
        if (storedData)
        {
            try
            {
                const data: EscalationData = JSON.parse(storedData);
                this.initializeWithData(data);
                sessionStorage.removeItem("escalationData");
            }
            catch (error)
            {
                this.error = "Failed to load escalation data";
                this.isLoading = false;
            }
        }
        else
        {
            this.route.queryParams.subscribe(params =>
            {
                if (params["message"])
                {
                    const data: EscalationData = {
                        message: decodeURIComponent(params["message"]),
                        brandId: params["brandId"] || this.$cxService.BrandId,
                        channelId: params["channelId"] || this.$cxService.ChannelId,
                        reason: params["reason"],
                        priority: params["priority"],
                        timestamp: params["timestamp"]
                    };
                    this.initializeWithData(data);
                }
                else
                {
                    this.error = "No escalation data found";
                    this.isLoading = false;
                }
            });
        }
    }

    private initializeWithData(data: EscalationData): void
    {
        this.escalationMessage = data.message;
        this.escalationDetails = {
            reason: data.reason,
            priority: data.priority,
            timestamp: data.timestamp
        };

        this.$cxService.initializeScript();

        try
        {
            this.$cxService.initializeWindowVariables(this.escalationMessage);
            this.isLoading = false;
        }
        catch (error)
        {
            this.error = "Failed to initialize chat service";
            this.isLoading = false;
        }
    }
}
